import { JwtTokenFullData } from 'multirpc-sdk';

import { ANKR_PAYMENT_NETWORK } from 'modules/payments/const';
import { MultiService } from 'modules/api/MultiService';
import { createQueryFnWithWeb3ServiceGuard } from 'store/utils/createQueryFnWithWeb3ServiceGuard';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

import { IFetchIsOldAccountParams } from './fetchIsOldAccount';

export interface IFetchOldAccountJWTParams extends IFetchIsOldAccountParams {}

const fetchOldAccountJWTFallback: JwtTokenFullData = {};

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchOldAccountJWT },
  useFetchOldAccountJWTQuery,
  useLazyFetchOldAccountJWTQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchOldAccountJWT: build.query<
      JwtTokenFullData,
      IFetchOldAccountJWTParams
    >({
      queryFn: createQueryFnWithWeb3ServiceGuard({
        fallback: { data: fetchOldAccountJWTFallback },
        queryFn: async ({ params: { account }, web3Service }) => {
          // The worker seals the endpoint token, so the decrypted JWT is
          // converted by the accounting gateway, which carries the auth token.
          const data = await web3Service.getOldPremiumJwtToken(
            account,
            ANKR_PAYMENT_NETWORK,
            jwtToken =>
              MultiService.getService()
                .getAccountingGateway()
                .convertJwtToApiKey({ jwt_token: jwtToken }),
          );

          return { data };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  selectDataWithFallbackCachedByParams: selectOldAccountJWT,
  selectLoadingCachedByParams: selectOldAccountJWTLoading,
  selectStateCachedByParams: selectOldAccountJWTState,
} = createQuerySelectors({
  endpoint: fetchOldAccountJWT,
  fallback: fetchOldAccountJWTFallback,
});
